export const config = {
  backendUrl: process.env.VUE_APP_BACKEND_URL,
  backendToken: process.env.VUE_APP_BACKEND_TOKEN,
};
